import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'svg-frontends-form-block',
	styleUrls: ['./form-block.component.scss'],
	templateUrl: './form-block.component.html',
	standalone: false,
})
export class FormBlockComponent {
	@Input() label: string | TemplateRef<any>;
}
